import { http } from '@/http'

// initial state
const state = {
  summary: {},
  items: [],
  list: []
}
// getters
const getters = {}
// actions
const actions = {
  getData ({ commit }, { countyId, date } = {}) {
    http.get('/canmou/tianji/county/list', {
      params: { location_id: countyId, date }
    }).then(res => {
      const data = res.data
      if (data.status === 0) {
        const val = data.data
        commit('setSummary', val.summary)
        commit('setItems', val.items)
      }
    })
    http.get('/canmou/tianji/county/flow', {
      params: { location_id: countyId, date }
    }).then(res => {
      const data = res.data
      if (data.status === 0) {
        commit('setList', data.data)
      }
    })
  }
}

// mutations
const mutations = {
  initAll (state, values = {}) {
    for (let key in values) {
      state[key] = values[key]
    }
  },
  setSummary (state, summary) {
    state.summary = summary
  },
  setItems (state, items) {
    state.items = items
  },
  setList (state, list) {
    state.list = list
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
